import NiceModal, {NiceModalHocProps} from "@ebay/nice-modal-react";
import React, {ReactNode, useEffect} from "react";
import {Colors, Container, Text} from "../../../../ui";
import {Dialog, ImgTermsAndConditions} from "../../../bounce-ui";

interface TermsAndConditionsDialogProps extends NiceModalHocProps {
  PaymentTermsAndConditionsV2: ReactNode | string;
  pageViewEvent: (event: any) => void;
  page: string;
}

export const TermsAndConditionsDialog = NiceModal.create(
  ({PaymentTermsAndConditionsV2, pageViewEvent, page}: TermsAndConditionsDialogProps) => {
    useEffect(() => {
      pageViewEvent({page});
    }, []);

    return (
      <Dialog title={"Terms & Conditions"} buttonText={"Close"} image={<ImgTermsAndConditions />}>
        <Container
          sx={{
            width: "300px",
            gap: "20px",
          }}
        >
          <Text size={12} color={Colors.grey._800} sx={{whiteSpace: "pre-wrap"}}>
            {PaymentTermsAndConditionsV2}
          </Text>
        </Container>
      </Dialog>
    );
  }
);
